module.exports = __webpack_public_path__ + "img/La.4fda7b8d.png";